import React, { useState } from "react";

import { useFormikContext } from "formik";

import { MenuItem, TextField } from "@material-ui/core";

export default function Presets({ items, labelKey, ...props }) {
  const [value, setValue] = useState("");
  const formik = useFormikContext();
  const keys = Object.keys(items[0]);

  function handleChange(e) {
    const { value } = e.target;
    setValue(value);

    const item = items[value] || formik.initialValues;
    keys.forEach((key) => {
      formik.setFieldValue(key, item[key]);
    });
  }

  return (
    <TextField
      label="Presets"
      select
      value={value}
      onChange={handleChange}
      {...props}
    >
      <MenuItem value="">None</MenuItem>
      {items.map((item, key) => (
        <MenuItem disabled={item.disabled} key={key} value={key}>
          {item[labelKey]}
        </MenuItem>
      ))}
    </TextField>
  );
}
